import { z } from 'zod';

export const CardDetailsModel = {
    FULLY_OWNED: 'fully_owned',
    HOSTED_IFRAME: 'hosted_iframe',
    HOSTED_FIELDS: 'hosted_fields',
} as const;

export type CardDetailsModel = (typeof CardDetailsModel)[keyof typeof CardDetailsModel];

export function isProviderHostedCardDetailsModel(
    cardDetailsModel: CardDetailsModel | undefined
): boolean {
    return (
        cardDetailsModel === CardDetailsModel.HOSTED_IFRAME ||
        cardDetailsModel === CardDetailsModel.HOSTED_FIELDS
    );
}

export const CardDetailsModelSchema: z.ZodType<CardDetailsModel> = z.enum([
    CardDetailsModel.FULLY_OWNED,
    CardDetailsModel.HOSTED_IFRAME,
    CardDetailsModel.HOSTED_FIELDS,
]);

export interface IpgCardDetailsModelPolicy {
    readonly capable_models: readonly CardDetailsModel[];
    readonly enabled_models: readonly CardDetailsModel[];
    readonly default_model: CardDetailsModel;
}

export type IpgCardDetailsModelResolution =
    | {
          readonly success: true;
          readonly model: CardDetailsModel;
      }
    | {
          readonly success: false;
          readonly model: CardDetailsModel;
          readonly reason: 'unsupported' | 'disabled';
          readonly message: string;
      };
